import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { NA_INTRO, NA_TITLE, isMiataPart } from '../../server/store-collections.js';
import { ProductTile } from './Home.jsx';

// /store/na-miata-accessories: the Miata parts in one place, for people searching "NA Miata accessories".
export default function NaAccessoriesPage({ products = [], onOpen, onPrefetch, onBack }) {
  const parts = products.filter(isMiataPart);
  return <section className="shop-section collection-page"><div className="shop-wrap">
    {onBack && <button type="button" className="shop-link privacy-back" onClick={onBack}><ChevronLeft aria-hidden="true" />Back to the store</button>}
    <header className="shop-section-head collection-head">
      <span className="shop-eyebrow">NA Miata</span>
      <h1 className="shop-title">{NA_TITLE}</h1>
      {NA_INTRO.map((text) => <p key={text} className="collection-intro">{text}</p>)}
    </header>
    {parts.length ? <div className="shop-grid" style={{ '--cols': Math.min(3, parts.length) }}>{parts.map((product, index) => <ProductTile key={product.id} product={product} onOpen={onOpen} onPrefetch={onPrefetch} i={index} />)}</div>
      : <p className="collection-intro">New parts are on the way.</p>}
  </div></section>;
}
